<template>
  <div>
    <v-card outlined class="pa-4">
      <v-row class="ma-0">
        <!-- Title -->
        <v-col cols="12" class="pa-0">
          <div v-html="meterName"></div>
        </v-col>

        <!-- Value -->
        <v-col cols="12" class="mt-3">
          <v-row>
            <h1>{{ isNaN(value) ? 'Error' : value }} &nbsp; </h1>
            <div v-html="meterUnitName"></div>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'BoxCard',

  // TDS = ค่าสารทั้งหมดที่ละลายได้ PPM
  // EC = ค่าการนำไฟฟ้า μS/cm
  // LEVEL = ระดับน้ำ M
  // PRS = แรงดันน้ำ Bar
  // TOTAL = ปริมาตรน้ำ M^3
  // FLOW = อัตราการไหล M^3/Hr

  props: {
    value: {
      type: Number,
      default: 0
    },
    sensorType: {
      type: String,
      default: 'TDS',
    },
    sensorName: {
      type: String,
      default: 'ค่ามวลสารละลายรวมในน้ำ'
    }
  },

  computed: {
    meterName() {
      let _unitName = "";
      switch (this.sensorType) {
        case 'TDS':
          _unitName = `<h5> ค่าสารทั้งหมดที่ละลายได้ (TDS) </h5>`;
          break;
        case 'EC':
          _unitName = `<h5> ค่าการนำไฟฟ้า (EC) </h5>`;
          break;
        case 'LEVEL':
          _unitName = `<h5> ระดับน้ำ (Level) </h5>`;
          break;
        case 'PRS':
          _unitName = `<h5> แรงดันน้ำ (Pressure) </h5>`;
          break;
        case 'TOT':
          _unitName = `<h5> ปริมาตรการไหลสะสม (Total) </h5>`;
          break;
        case 'FLOW':
          _unitName = `<h5> อัตราการไหล (Flow Rate) </h5>`;
          break;
        default:
          _unitName = `<h5> ไม่ทราบรูปแบบการวัดค่า</h5>`;
          break;
      }
      return _unitName;
    },
    meterUnitName() {
      let _unitName = "";
      switch (this.sensorType) {
        case 'TDS':
          _unitName = `<h1> PPM </h1>`;
          break;
        case 'EC':
          _unitName = `<h1> μS/cm </h1>`;
          break;
        case 'LEVEL':
          _unitName = `<h1> M </h1>`;
          break;
        case 'PRS':
          _unitName = `<h1> Bar </h1>`;
          break;
        case 'TOT':
          _unitName = `<h1> M<sup>3</sup> </h1>`;
          break;
        case 'FLOW':
          _unitName = `<h1> M<sup>3</sup>/Hr </h1>`;
          break;
        default:
          _unitName = `<h1> - </h1>`;
          break;
      }
      return _unitName;
    },
  }
}
</script>
